import React, {Fragment} from "react"
//redux
import {useSelector, useDispatch} from "react-redux"
import moment from "moment-timezone"
import {P} from "@uprise/text"
import {text} from "@uprise/typography"
import {SlotTextContainer, SlotText, SlotsContainer} from "./index.style"
import {bookingDataSelector, setBookingSlot} from "../../bookingSlice"
import {authSelector} from "features/Auth/authSlice"
import {check24HrsBookingPermission} from "helpers/utils"

const BoookingSlotsBlock = ({
	data,
	setSelectedCoach,
	setTime,
	timeZone = "Australia/Sydney",
	coach,
	dayOffset,
	weekView = false
}) => {
	const dispatch = useDispatch()
	const {bookingSlot} = useSelector(bookingDataSelector)
	const {data: userData} = useSelector(authSelector)

	const startTime = slot => moment(slot.start).tz(timeZone)

	const currentTime = moment().tz(timeZone)
	const dayStart = moment.tz(moment().add(dayOffset, "days").startOf("day").format("YYYY-MM-DD HH:mm"), timeZone)

	const isUserEligibleFor24HrsBooking = check24HrsBookingPermission(userData?.role)

	const day = data.filter(slot => {
		const currentSlot = startTime(slot)
		const diff = currentSlot.diff(currentTime, "hours")
		let time1 = startTime(slot).startOf("day").add(9, "hours")
		let time2 = startTime(slot).startOf("day").add(17, "hours")
		if (!weekView) {
			time1 = dayStart.clone().startOf("day").add(9, "hours")
			time2 = dayStart.clone().startOf("day").add(17, "hours")
		}

		if (startTime(slot).isBetween(time1, time2, "undefined", "[)")) {
			if (diff < 24) return isUserEligibleFor24HrsBooking
			else return true
		}
	})

	const evening = data.filter(slot => {
		const currentSlot = startTime(slot)
		const diff = currentSlot.diff(currentTime, "hours")
		let time1 = startTime(slot).startOf("day").add(17, "hours")
		let time2 = startTime(slot).startOf("day").add(24, "hours")
		if (!weekView) {
			time1 = dayStart.clone().startOf("day").add(17, "hours")
			time2 = dayStart.clone().startOf("day").add(24, "hours")
		}

		if (startTime(slot).isBetween(time1, time2, "undefined", "[)")) {
			if (diff < 24) return isUserEligibleFor24HrsBooking
			else return true
		}
	})

	const morning = data.filter(slot => {
		const currentSlot = startTime(slot)
		const diff = currentSlot.diff(currentTime, "hours")
		let time1 = startTime(slot).startOf("day").add(0, "hours")
		let time2 = startTime(slot).startOf("day").add(9, "hours")
		if (!weekView) {
			time1 = dayStart.clone().startOf("day").add(0, "hours")
			time2 = dayStart.clone().startOf("day").add(9, "hours")
		}
		if (startTime(slot).isBetween(time1, time2, "undefined", "[)")) {
			if (diff < 24) return isUserEligibleFor24HrsBooking
			else return true
		}
	})

	const epoch = date => moment(date).unix()

	return (
		<>
			{[morning, day, evening].map(time => (
				<>
					{time.length ? (
						<SlotsContainer>
							{time?.map((slot, index) => (
								<Fragment key={index}>
									<SlotTextContainer
										active={epoch(bookingSlot?.start) === epoch(slot.start)}
										data-testid={moment(slot.start).format("DD-MM-YYYY-HH:mm")}
										onClick={() => {
											setSelectedCoach(coach)
											setTime(slot)
											dispatch(setBookingSlot(slot))
										}}>
										<SlotText active={epoch(bookingSlot?.start) === epoch(slot.start)}>
											{startTime(slot).format("hh:mm A")}
										</SlotText>
									</SlotTextContainer>
								</Fragment>
							))}
						</SlotsContainer>
					) : (
						<SlotsContainer>
							<P className='m-t-2' fontSize={text.t4}>
								No Slots
							</P>
						</SlotsContainer>
					)}
				</>
			))}
		</>
	)
}

export default BoookingSlotsBlock
